import React from 'react';
import { Switch, Route } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addNotificationAction, openModalAction, logout } from '../../actions/Actions';
import { withRouter } from 'react-router-dom';
import AllCampaigns from '../sms_campaign/AllCampains';
import NewCampaign from '../sms_campaign/NewCampaign';
import CampaignDetail from '../sms_campaign/CampaignDetail';
import './sms-campaign.scss'

const SMSCampaign = ({ lang, openModal, addNotification, history }) => {
  return (
    <Switch>
      <Route
        path="/sms-campaigns/create"
        component={() => <NewCampaign lang={lang} openModal={openModal} addNotification={addNotification} />}
      />
      <Route
        path="/sms-campaigns/edit/:id"
        render={({ match }) => {
          const id = match.params.id;
          return <NewCampaign lang={lang} id={id} openModal={openModal} addNotification={addNotification} />
        }}
      />
      <Route
        path="/sms-campaigns/detail/:id"
        render={({ match }) => {
          const id = match.params.id;
          if (id) {
            return <CampaignDetail lang={lang} id={id} addNotification={addNotification} history={history} />;
          }
        }}
      />
      <Route
        component={() => <AllCampaigns lang={lang} addNotification={addNotification} logout={logout} />}
      />
    </Switch>
  )
};

export default withRouter(connect(
  state => ({
    lang: state.lang,
  }),
  dispatch => ({
    addNotification: bindActionCreators(addNotificationAction, dispatch),
    openModal: bindActionCreators(openModalAction, dispatch),
    logout: bindActionCreators(logout, dispatch)
  }),
)(SMSCampaign));
